export enum UploadFileStateEnum {
    UPLOADING = 'UPLOADING',
    RESUMING = 'RESUMING',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED',
    PAUSED = 'PAUSED',
    SUCCESS = 'SUCCESS'
}